import React, {FC} from 'react';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {
  TooltipCoordinator,
  TooltipCoordinatorProps,
} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {ThemeContextType} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {EducationTooltipContent, EducationTooltipContentProps} from './educationTooltipContent';

/*
 * Props.
 */

export interface EducationTooltipCoordinatorProps
  extends EducationTooltipContentProps,
    Omit<
      TooltipCoordinatorProps,
      'render' | 'persistent' | 'isMultiline' | 'minWidth' | 'maxWidth' | keyof ThemeContextType
    > {
  width?: number;
  onShow?: Handler;
}

/*
 * Component.
 */

/**
 * Implements the "Info tooltips with actions" column at
 * https://www.figma.com/file/P5Z8T40LdXcuNbVGvsaey610/%E2%9C%A8-%F0%9F%96%A5-Education-tips?node-id=1022%3A0
 */
export const EducationTooltipCoordinator: FC<EducationTooltipCoordinatorProps> = ({
  titleIcon,
  title,
  tooltip,
  buttons,
  onShow,
  width = 240,
  ...tooltipProps
}) => (
  <TooltipCoordinator
    persistent
    isMultiline
    maxWidth={width}
    minWidth={width}
    render={() => (
      <EducationTooltipContent
        titleIcon={titleIcon}
        title={title}
        tooltip={tooltip}
        buttons={buttons}
        onShow={onShow}
      />
    )}
    {...tooltipProps}
  />
);
